import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DtRecordsService {
  constructor() {}

  private updateDTRecordsSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private updateDTRecords$: Observable<boolean> = this.updateDTRecordsSubject.asObservable();

  public set(state) {
    this.updateDTRecordsSubject.next(state);
  }

  public select<T>() {
    return this.updateDTRecords$;
  }
}
